
import { ref, watch, toRaw, isRef } from 'vue'

import equal from 'fast-deep-equal'
import rfdc from 'rfdc'

export const useClone = rfdc()

export const useIsUpdated = (editItem) => {
  const getValue = () => (isRef(editItem) ? editItem.value : editItem)

  const original = ref(useClone(toRaw(getValue())))
  const isUpdated = ref(false)
  const isUpdating = ref(false)

  watch(
    getValue,
    (newVal) => {
      isUpdated.value = !equal(toRaw(newVal), original.value)
    },
    { deep: true }
  )

  const setOriginal = (newOriginal) => {
    original.value = useClone(toRaw(newOriginal))
    isUpdated.value = false
  }

  const reset = () => {
    original.value = useClone(toRaw(getValue()))
    isUpdated.value = false
  }

  return { isUpdated, isUpdating, original, reset, setOriginal }
}

